<template>
  <div class="subflow">
    <!-- <VMarketplaceFormControls
      ref="auctionForm"
      :car="auction"
      class="pb-3"
      @success="onSubmitAuctionForm"
    /> -->

    <TheMarketplaceForm 
      v-if="showForm" 
      :car="auction"
      @success="onSubmitCarForm"
    />
  </div>
</template>
<script>
import TheMarketplaceForm from '../SellCarForm/TheMarketplaceForm'
// import VMarketplaceFormControls from './VMarketplaceFormControls'

export default {
  name: 'VMarketplaceForm',

  components: {
    TheMarketplaceForm,
    // VMarketplaceFormControls
  },

  props: {
    auction: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    formData: {},
    showForm: false,
    auctionForm: {}
  }),

  watch: {
    show(v) {
      if (!v) {
        setTimeout(() => {
          this.showForm = v
        }, 500)
      } else {
        this.showForm = v
      }
    }
  },

  methods: {
    async onSubmitCarForm() {
      if (this.$refs.auctionForm) {
        await this.$refs.auctionForm.saveDates()
      }

      this.showModalAndClose()
    },

    onSubmitAuctionForm () {
      this.showModalAndClose()
    },

    showModalAndClose() {
      const modalSuccess = {
        title: 'Updated successfully',
        body: `Car <strong>${this.auction.title}</strong> was updated`
      }
      this.$modals.open(modalSuccess)

      setTimeout(() => {
        this.$modals.close()
      }, 3000)
    },

    onInputCarDetails (v) {
      this.formData = v
    }
  }
}
</script>
